export const COLLECTION_API_BASE_PATH = '/backoffice/collection';
export const MASTER_DATA_BASE_PATH = '/backoffice/master-data';

export const COLLECTION_API_ENDPOINTS = {
  LHC_LIST: `${COLLECTION_API_BASE_PATH}/lhc`,
  LHC_DETAIL: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}/items`,
  CREATE_LHC: `${COLLECTION_API_BASE_PATH}/lhc`,
  UPDATE_LHC: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}`,
  LHC_EXPORT: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}/export`,
  COLLECTION_PLANTS: `${MASTER_DATA_BASE_PATH}/collection-plants`,
};

export const COLLECTION_QUERY_KEYS = {
  LHC_LIST: 'CollectionLHCList',
  LHC_DETAIL: 'CollectionLHCDetail',
  COLLECTION_PLANTS: 'CollectionPlants',
} as const;
